export const PERMISSIONS = {
  OVERVIEW: "OVERVIEW",
  MERCHANT_INDIVIDUAL_MERCHANT: "MERCHANT_INDIVIDUAL_MERCHANT",
  MERCHANT_BUSINESS_MERCHANT: "MERCHANT_BUSINESS_MERCHANT",
  MERCHANT_MIN_KYC_USER: "MERCHANT_MIN_KYC_USER",
  MERCHANT_NCMC_USER:"MERCHANT_NCMC_USER",
  MERCHANT_FOS_USER:"MERCHANT_FOS_USER",
  ADMIN_ADD: "ADMIN_ADD",
  ADMIN_VIEW: "ADMIN_VIEW",
  PARTNER_ADD: "PARTNER_ADD",
  PARTNER_VIEW: "PARTNER_VIEW",
  PARTNER_MIS_DASHBORAD: "PARTNER_MIS_DASHBORAD",
  PARTNER_MIS_CUSTOMER_REGISTRATION: "PARTNER_MIS_CUSTOMER_REGISTRATION",
  PARTNER_MIS_TRANSACTIONS: "PARTNER_MIS_TRANSACTIONS",
  PARTNER_MIS_SETTLEMENT: "PARTNER_MIS_SETTLEMENT",
  PAYMENT_SETTING_ADD_NEW: "PAYMENT_SETTING_ADD_NEW",
  PAYMENT_SETTING_LIST: "PAYMENT_SETTING_LIST",
  PAYMENT_SETTING_DEFAULT: "PAYMENT_SETTING_DEFAULT",
  PAYMENT_SETTING_MCC_CONFIGURATION: "PAYMENT_SETTING_MCC_CONFIGURATION",
  PAYMENT_SETTING_CASHBACK_CONFIGURATION: "PAYMENT_SETTING_CASHBACK_CONFIGURATION",
  MANAGE_PERMISSION: "MANAGE_PERMISSION",
  MANAGE_CARD_ASSIGN_CARD: "MANAGE_CARD_ASSIGN_CARD",
  MANAGE_CARD_PHYSICAL_CARD: "MANAGE_CARD_PHYSICAL_CARD",
  MANAGE_CARD_VIRTUAL_CARD: "MANAGE_CARD_VIRTUAL_CARD",
  MANAGE_CARD_ORDER_LIST: "MANAGE_CARD_ORDER_LIST",
  MANAGE_SOUNDBOX_ORDER:"MANAGE_SOUNDBOX_ORDER",
  CPV_LISTING:"CPV_LISTING",
  TRANSACTION_PAYMENT: "TRANSACTION_PAYMENT",
  TRANSACTION_SETTLEMENT: "TRANSACTION_SETTLEMENT",
  MANAGE_REPORT: "MANAGE_REPORT",
  MANAGE_REPORT_BY_TRANSACTIONS: "MANAGE_REPORT_BY_TRANSACTIONS",
  MANAGE_DAILY_REPORT: "MANAGE_DAILY_REPORT",
  MANAGE_HOLD_BALANCE_REPORT: "MANAGE_HOLD_BALANCE_REPORT",
  MANAGE_OFFLINE_TRANSACTION_REPORT: "MANAGE_OFFLINE_TRANSACTION_REPORT",
  SEND_NOTIFICATION: "SEND_NOTIFICATION",
  TICKET_MANAGEMENT: "TICKET_MANAGEMENT",
  HELP_SUPPORT: "HELP_SUPPORT",
  MANAGE_OPERATOR: "MANAGE_OPERATOR",
  LOGIN_HISTORY: "LOGIN_HISTORY",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  MANAGE_PAYBACK: "MANAGE_PAYBACK",
  MANAGE_PAYBACK_APPROVAL_USER_LIST: "MANAGE_PAYBACK_APPROVAL_USER_LIST",
  MANAGE_PAYBACK_REQUEST_LIST: "MANAGE_PAYBACK_REQUEST_LIST",
  MANAGE_DISTRIBUTOR_ADD: "MANAGE_DISTRIBUTOR_ADD",
  MANAGE_DISTRIBUTOR_VIEW: "MANAGE_DISTRIBUTOR_VIEW",
  PARTNER_SOCIETY_PARTNER: "PARTNER_SOCIETY_PARTNER",
  TID_WHITELISTING: "TID_WHITELISTING",
  MANAGE_MAIN_REPORT: "MANAGE_MAIN_REPORT",
  MANAGE_APPROVE_EMAIL_REPORTS: "MANAGE_APPROVE_EMAIL_REPORTS",
  MANAGE_ORG_SETTLEMENT_REPORTS: "MANAGE_ORG_SETTLEMENT_REPORTS",
  MANAGE_ORG_TRANSACTION_REPORTS: "MANAGE_ORG_TRANSACTION_REPORTS",
  MANAGE_UPI_REPORTS: "MANAGE_UPI_REPORTS",
  LIST_NOTIFICATION: "LIST_NOTIFICATION",
  RECONCILE_APPROVAL_USER_LIST: "RECONCILE_APPROVAL_USER_LIST",
  RECONCILE_REQUEST_LIST: "RECONCILE_REQUEST_LIST",
  GENERATE_REPORT: "GENERATE_REPORT",
  VIEW_USER_LIST: "VIEW_USER_LIST",
  PROFILE: "PROFILE",
  LOGOUT: "LOGOUT",
  PERMISSION_MANAGEMENT: "PERMISSION_MANAGEMENT",
  ROLE_MANAGEMENT: "ROLE_MANAGEMENT",
  ORGANIZATION_HUB: "ORGANIZATION_HUB",
  ORG_CARD_MANAGEMENT: "ORG_CARD_MANAGEMENT",
  CARD_MANAGEMENT: "CARD_MANAGEMENT",
  QR_INVENTORY: "QR_INVENTORY",
  SOUNDBOX_INVENTORY: "SOUNDBOX_INVENTORY",
  QR_REQUEST: "QR_REQUEST",
  TRANSACTION_CHARGES: "TRANSACTION_CHARGES",
  CARD_INVENTORY_LIST:"CARD_INVENTORY_LIST",
  FORM_60:"FORM_60",
  INVENTORY_FILE_LIST:"INVENTORY_FILE_LIST",
  MANAGE_AUTOPAY:"MANAGE_AUTOPAY",
};
